import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useRef } from 'react';
import { useState } from 'react';
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import { useApplicationContext } from '../../Context/applicationContext';
import KenStepperFooter from '../KenApplicationForm/Components/KenStepperFooter';
import ThankYouPage from '../KenApplicationForm/Components/ThankYouPage';
import KenSummaryStep from '../KenSummaryPage';
import { useNavigate } from 'react-router-dom';

import FormStep from './Form';
import { createUpdateApplication } from '../../Utils/apiServices';
import { useAppContext } from '../../Context/appContext';
import Declaration from '../KenApplicationForm/Components/DeclarationPage';
import DocumentUpload from './DocumentUpload';

// Any special cases like payments,summary based on the stepType will be handled
// NOTE: These special steps should be coupled with any other steps

const useStyles = makeStyles((theme) => ({
  thankYouContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: '80%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
  title: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '500',
      'font-size': '20px',
      'line-height': '23px',
      color: '#000000',
    },
  },
  subTitle: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '400',
      'font-size': '16px',
      'line-height': '150%',
      'text-align': 'center',
      color: '#505F79',
    },
  },
  link: {
    color: '#0000EE',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export default function Stepper({ step }) {
  const { applicationState, applicationDispatch } = useApplicationContext();
  const formRef = useRef();
  console.log('Stepper');

  // based on stepType return components

  const getStepContent = () => {
    console.log('Stepper : getStepContent');

    switch (step?.stepType) {
      case 'payment':
        return <PaymentStep />;

      case 'summary':
        return (
          <SummaryStep
            applicationState={applicationState}
            applicationDispatch={applicationDispatch}
          />
        );
      case 'documentUpload':
        return (
          <DocumentUpload
            applicationState={applicationState}
            applicationDispatch={applicationDispatch}
          />
        );

      case 'declaration':
        return (
          <DeclarationStep
            applicationState={applicationState}
            applicationDispatch={applicationDispatch}
          />
        );

      default:
        return <FormStep step={step} ref={formRef} />;
    }
  };

  return (
    <>
      {/* render step by id */}
      {/* <KenStepperHeader activeStep={step} /> */}

      <Box m={2} alignItems="center" justifyContent="center">
        {getStepContent()}
      </Box>
    </>
  );
}

const PaymentStep = () => {
  return <>Payment Step</>;
};

const DeclarationStep = (props) => {
  const { applicationState, applicationDispatch } = props;
  const { dispatch: dispatchAppContext } = useAppContext();

  const handlePrev = () => {
    applicationDispatch({ type: 'prevStep' });
  };

  const handleNext = () => {
    let data = applicationState?.applicationData?.application;
    data.currentStep = '7';
    dispatchAppContext({ type: 'udpateLoading', value: true });

    createUpdateApplication({
      applicationId: applicationState?.applicationId,
      application: { ...data },
    })
      .then((res) => {
        dispatchAppContext({ type: 'udpateLoading', value: false });
        // on success update context data and active step
        if (res?.success) {
          // update context
          applicationDispatch({
            type: 'update',
            payload: { applicationData: res.data },
          });
          applicationDispatch({ type: 'nextStep' });
          // setShowThankYou(true);
          // applicationDispatch({ type: 'showHeader' });
        }
      })
      .catch((err) => {
        dispatchAppContext({ type: 'udpateLoading', value: false });
        //alert user of failure > try again
        console.log('Updating data failed. Try again');
      });
  };

  return (
    <>
      <Box sx={{ margin: '0 auto' }}>
        <Declaration
          formJson={applicationState.steps}
          data={applicationState.applicationData}
          applicationState={applicationState}
        />
      </Box>
      <KenStepperFooter
        totalSteps={applicationState.totalSteps}
        activeStep={applicationState.activeStep}
        onPrev={handlePrev}
        onNext={handleNext}
        isSave={false}
        applicationStatus={
          applicationState?.applicationData?.application?.applicationStatus
        }
      />
    </>
  );
};

const SummaryStep = (props) => {
  const { applicationState, applicationDispatch } = props;
  const { dispatch: dispatchAppContext } = useAppContext();

  const classes = useStyles();
  const [showThankYou, setShowThankYou] = useState(false);
  const navigate = useNavigate();

  const handlePrev = () => {
    applicationDispatch({ type: 'prevStep' });
  };
  const handleNext = () => {
    let data = applicationState?.applicationData?.application;
    data.hed__Application_Status__c = 'Application form Submitted';
    data.Current_Step__c = 3;
    dispatchAppContext({ type: 'udpateLoading', value: true });

    createUpdateApplication({
      applicationId: applicationState?.applicationId,
      application: { ...data },
    })
      .then((res) => {
        dispatchAppContext({ type: 'udpateLoading', value: false });
        // on success update context data and active step
        if (res?.success) {
          // update context
          applicationDispatch({
            type: 'update',
            payload: { applicationData: res.data },
          });
          applicationDispatch({ type: 'nextStep' });
          applicationDispatch({ type: 'showHeader' });
          navigate('/thankYou', {
            state: {
              title: 'Registered Successfully',
              description: `Your application has been submitted successfully.`,
              link: '/homepage',
              redirect: 'Dashboard',
            },
          });
        }
      })
      .catch((err) => {
        dispatchAppContext({ type: 'udpateLoading', value: false });
        //alert user of failure > try again
        console.log('Updating data failed. Try again');
      });
  };
  return (
    <>
      {/* Summary */}
      {!showThankYou ? (
        <>
          <Box sx={{ width: '80vw', margin: '0 auto' }}>
            <KenSummaryStep
              formJson={applicationState.steps}
              data={applicationState.applicationData}
              applicationState={applicationState}
            />
          </Box>
          <KenStepperFooter
            totalSteps={applicationState.totalSteps}
            activeStep={applicationState.activeStep}
            onPrev={handlePrev}
            onNext={handleNext}
            isSave={false}
            applicationStatus={
              applicationState?.applicationData?.application?.applicationStatus
            }
          />
        </>
      ) : (
        <Box
          margin="auto"
          height="90%"
          p={2}
          display="flex"
          justifyContent="center"
          alignContent="center"
          flexDirection="column"
        >
          <ThankYouPage
            wrapperClassName={classes.thankYouContainer}
            titleClass={classes.title}
            subTitleClass={classes.subTitle}
            title="Thank you for your Application"
            redirection={false}
            description={
              <Typography>
                You have successfully Applied for
                {` ${applicationState?.applicationData?.application?.formName}`}
                <div style={{ fontSize: 14 }}>
                  Click here to redirect to{' '}
                  <span
                    className={classes.link}
                    onClick={() => {
                      applicationDispatch({ type: 'showHeader' });
                      navigate('/home');
                    }}
                  >
                    Homepage
                  </span>
                </div>
              </Typography>
            }
          />
        </Box>
      )}
    </>
  );
};
